export default __webpack_public_path__ + "static/media/readme-creator.c6e5c3db.png";